import { FC, memo, ReactNode } from 'react'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ButtonBase from '@mui/material/ButtonBase'
import { CompanyCard } from '@leadgen/models/client'
import { useMidnightIntervalMemo } from '../../../../hooks/shared/useMidnightIntervalMemo'
import useCallbackDebounced from '../../../../hooks/shared/useCallbackDebounced'
import { PaymentCardIcon } from '../../../atoms/PaymentCardIcon'
import Radio from '@mui/material/Radio'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const CompanyCardRow: FC<{
  companyCard: CompanyCard
  selectable?: boolean
  isDefaultCard?: boolean
  isSelected?: boolean
  disabled?: boolean
  onClick?: (companyCardId: string) => void
  menuElement?: ReactNode
}> = ({ companyCard, selectable, isSelected, isDefaultCard, disabled, onClick, menuElement }) => {
  const companyCardExpired = useMidnightIntervalMemo(() => {
    const now = new Date()
    const companyCardExpired =
      companyCard.expiryYear < now.getFullYear() ||
      (companyCard.expiryYear === now.getFullYear() && companyCard.expiryMonth < now.getMonth() + 1)
    return companyCardExpired
  }, [companyCard.expiryMonth, companyCard.expiryYear])
  const handleSelectCard = useCallbackDebounced(() => {
    onClick?.(companyCard.id)
  }, [companyCard.id, onClick])
  return (
    <ButtonBase
      component="div"
      disabled={disabled}
      disableRipple={!onClick}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        padding: 1,
        backgroundColor: '#f0f0f0',
        cursor: onClick ? 'pointer' : 'default',
        borderRadius: 1,
      }}
      onClick={handleSelectCard}
    >
      {selectable && (
        <Box sx={{ display: 'flex' }}>
          <Radio checked={isSelected} size="small" />
        </Box>
      )}
      {isDefaultCard && (
        <Box sx={{ display: 'flex', paddingLeft: 1, paddingRight: 1 }}>
          <CheckCircleIcon fontSize="small" color="success" />
        </Box>
      )}
      <Box sx={{ display: 'flex', paddingLeft: selectable ? 0 : 1 }}>
        <PaymentCardIcon brand={companyCard.brand} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          paddingLeft: 2,
          paddingRight: 2,
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle2">**** {companyCard.last4}</Typography>
        <Box sx={{ flex: 1 }} />
        <Typography variant="subtitle2">
          {companyCard.brand !== 'visa' &&
          companyCard.brand !== 'amex' &&
          companyCard.brand !== 'mastercard' &&
          companyCard.brand !== 'mc'
            ? companyCard.brand.toUpperCase()
            : ''}{' '}
          Expires {`${('0' + companyCard.expiryMonth).slice(-2)}/${companyCard.expiryYear}`}{' '}
        </Typography>
      </Box>
      {companyCardExpired && <ErrorOutlineIcon />}
      {menuElement}
    </ButtonBase>
  )
}

export default memo(CompanyCardRow)
